// PRJ1417943 - Integration Accelerator - Updtaed import to use getAgencyErrors
import { getAgencyErrors } from './agencies';

import SERVER_ERRORS from './server';

export default { ...SERVER_ERRORS, getAgencyErrors };
